var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"list-item dF aC jC",staticStyle:{"height":"65px","width":"65px","text-align":"center"},attrs:{"data-file-id":_vm.item.id},on:{"click":function($event){return _vm.$emit('select', _vm.item)}}},[_c('img',{attrs:{"src":`${_vm.resURL}${_vm.item.path}`}})])
}
var staticRenderFns = []

export { render, staticRenderFns }